/**
 * A class decorator that defines a custom element if it is not already defined.
 *
 * @param {string} tagName The name of the custom element to define.
 */
export const customElementSafe = (tagName) => (clazz) => {
    if (!window.customElements.get(tagName)) {
        window.customElements.define(tagName, clazz);
    }
    // We don't need to return anything from the decorator.
    // It's a "class decorator" that just performs an action.
};
